import { render, staticRenderFns } from "./UpcomingApptNotice.vue?vue&type=template&id=6d3e5b2c&lang=pug"
import script from "./UpcomingApptNotice.vue?vue&type=script&lang=js"
export * from "./UpcomingApptNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports